import * as React from "react";
import "../styles/projectcard.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { useEffect } from "react";
import 'tippy.js/themes/light.css';


export default function ProjectCard(props: any) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  useEffect(() => {
    setTimeout(() => {
      const iconTooltips = document.querySelectorAll('.icon-tooltip');
      const tooltipInstances: any = [];
  
      iconTooltips.forEach((element) => {
        const title = element.getAttribute('data-title');
        const tooltip = tippy(element, {
          content: title || '',
          theme: 'light',
        });
        tooltipInstances.push(tooltip);
      });
  
      return () => {
        tooltipInstances.forEach((tooltip: any) => {
          tooltip.destroy();
        });
      };
    }, 0);
  }, []);
  
  return (
    <div
      className="col-lg-6"
    >
      <div className="card">
        <div className="card-body">
        <Slider {...settings} className="color: white">
          {props.images.map((image: any) => (
            <div key={image.id}>
              <img src={image.url} className="card__image" alt="project" />
            </div>
          ))}
        </Slider>
          <br />
          <br />
          <h4 className="card-title">{props.name}</h4>
          <p className="card-text" dangerouslySetInnerHTML={{ __html: props.description }}></p>
        </div>
        <button className="card__btn"  onClick={() => {
       window.open(props.link, "_blank");
       }}>View Project</button>
      </div>
    </div>
  );
}


